/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import type { LegacyOrganization, LegacyUser, OnLoggedIn } from 'types/legacyDashboard';

export interface AuthContextProps {
  isAuthenticated: boolean;
  user: Partial<LegacyUser>;
  organizations: Array<LegacyOrganization>;
  showMfaModal: boolean;
  loadingUserDetails: boolean;
  loggingIn: boolean;
  loggingOut: boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<void>;
  loginTotp: (totpCode: string) => Promise<void>;
  logout: () => Promise<void>;
  loginResult?: OnLoggedIn;
  loginError?: string;
  loginTotpError?: string;
  logoutError?: string;
  invalidate: () => void;
}

const AuthContext = createContext<AuthContextProps>({
  isAuthenticated: true,
  user: {},
  organizations: [],
  login: (_email, _password, _rememberMe) => Promise.resolve(),
  loginTotp: (_totpCode) => Promise.resolve(),
  logout: () => Promise.resolve(),
  loggingIn: false,
  loggingOut: false,
  showMfaModal: false,
  loadingUserDetails: false,
  invalidate: () => {},
});

export default AuthContext;
